import { createBrowserRouter } from "react-router-dom";
import { AppShell } from "./app-shell";
import { RestaurantPage } from "@/features/restaurant/restaurant-page";
import { MenuPage } from "@/features/menu/menu-page";
import { OrdersPage } from "@/features/orders/orders-page";
import { DeliveryPage } from "@/features/delivery/delivery-page";
import { AdminPage } from "@/features/admin/admin-page";
import { LoginPage } from "@/features/auth/login-page";
import { NotFoundPage } from "@/app/not-found-page";

/**
 * Dashboard routing.
 *
 * - `/`        -> Restaurant operations (logo upload + weekly hours)
 * - `/login`   -> Staff email/password (Better Auth). Public.
 * - `/menu`    -> Menu catalog CRUD
 * - `/orders`  -> Pickup orders with accept/reject and kitchen status
 * - `/delivery` -> Delivery zones
 * - `/admin`   -> ByteBite ADMIN area (session required; no extra role matrix)
 *
 * Unauthenticated visits to `/`, `/menu`, `/orders`, `/delivery`, and `/admin` redirect to
 * `/login` and return to the intended page after sign-in. Restaurant context
 * stays on the path (ADR-021), not `session.restaurantId`.
 *
 * The Dashboard must not access PostgreSQL directly; it calls the API.
 */
export const router = createBrowserRouter([
  {
    path: "/",
    element: <AppShell />,
    children: [
      { index: true, element: <RestaurantPage /> },
      { path: "login", element: <LoginPage /> },
      { path: "menu", element: <MenuPage /> },
      { path: "orders", element: <OrdersPage /> },
      { path: "delivery", element: <DeliveryPage /> },
      { path: "admin", element: <AdminPage /> },
      { path: "*", element: <NotFoundPage /> },
    ],
  },
]);
